/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/12/2020
 */
import Vue from "@/entry/setupVue3.js"

import QwLinkButton from "@/core/components/Controls/Buttons/QwLinkButton.vue";
import QwButton from "@/core/components/Controls/Buttons/QwButton.vue";

Vue.component('qw-button', QwButton)
Vue.component('qw-link-button', QwLinkButton)


